import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../../store/storeFunctions';

import ABw from '../../../../img/repi/Score_A_bw';
import BBw from '../../../../img/repi/Score_B_bw';
import CBw from '../../../../img/repi/Score_C_bw';
import DBw from '../../../../img/repi/Score_D_bw';
import EBw from '../../../../img/repi/Score_E_bw';
import AColor from '../../../../img/repi/Score_A_color';
import BColor from '../../../../img/repi/Score_B_color';
import CColor from '../../../../img/repi/Score_C_color';
import DColor from '../../../../img/repi/Score_D_color';
import EColor from '../../../../img/repi/Score_E_color';

import '../../repi.scss';

class RepiScore extends React.Component {
    render() {
        const { score } = this.props;

        if (isNullOrUndefined(score))
            return null;

        return (
            <div className="score">
                <table width="100%" height="100%">
                    <tbody>
                        <tr>
                            <td align="center">
                                {isNullOrUndefined(score.scoreRange) ? this.renderNoScore(score) : this.renderScoreRange(score)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    renderScoreRange = (score) => {
        return (
            <>
                <div className="columns is-vcentered is-mobile score-items">
                    {["a", "b", "c", "d", "e"].map(x => <div key={x}
                        className={`column is-${score.scoreRange.toLowerCase() !== x ? "2" : "4"} score-item`}
                    >
                        {this.renderScoreMark(x, false)}
                    </div>)}
                </div>
                <div className="score-text">
                    <h2><Translate id="Repi.Report.PaymentHistory.ScoreValue" />: {score.scoreRaw}</h2>
                    <p><Translate id={`Repi.Report.RepiScore${score.scoreRange.toUpperCase()}`} /></p>
                </div>
            </>
        );
    }

    renderNoScore = (score) => {
        const noScore = isNullOrUndefined(score) || isNullOrUndefined(score.noScore) ? 5 : score.noScore + 1;

        return (
            <>
                <div className="columns is-vcentered is-mobile score-items">
                    {["a", "b", "c", "d", "e"].map(x => <div key={x} className="column is-2 score-item">
                        {this.renderScoreMark(x, true)}
                    </div>)}
                </div>
                <div className="score-text">
                    <p><Translate id="Repi.Report.NoPossibleToCalculate" /></p>
                    <p>{score.noScore && <Translate id={`Repi.Report.NoScore${noScore}`} />}</p>
                </div>
            </>
        );
    }

    renderScoreMark = (value, bw = false) => {
        switch(value.toLowerCase()) {
            case "a": return bw ? <ABw /> : <AColor />;
            case "b": return bw ? <BBw /> : <BColor />;
            case "c": return bw ? <CBw /> : <CColor />;
            case "d": return bw ? <DBw /> : <DColor />;
            case "e": return bw ? <EBw /> : <EColor />;
        }
    }
}

export default connect(
    state => state.userContext,
    null
)(withLocalize(withRouter(RepiScore)));
